var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vt-app",attrs:{"id":"app"}},[_c('main',{staticClass:"vt-main"},[_c('vt-header',{on:{"on-change":_vm.onChangeHandler}}),_c('vt-content',{ref:"vtContent"}),_c('vt-footer',{on:{"on-click":_vm.onClickHandler}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }